module.exports = __webpack_public_path__ + "media/images/ic_chevron_right_black_24px-4d9d4e3db69569b09d4b20cbbcaa7c9a.svg";